import React from 'react';

import { useBackgroundJob } from '../../hooks/backgroundjobs/useBackgroundJob';
import SideDrawer from '../Modals/SideDrawer';
import BackgroundJobCard from './BackgroundJobCard';

interface BackgroundJobsDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

const BackgroundJobsDrawer: React.FC<BackgroundJobsDrawerProps> = ({
  isOpen,
  onClose,
}) => {
  const {
    jobs,
    downloadingJobUuid,
    downloadProgress,
    downloadJobFile,
  } = useBackgroundJob();

  const handleDownload = async (
    uuid: string,
    fileName?: string
  ) => {
    await downloadJobFile(uuid, fileName);
  };

  return (
    <SideDrawer
      isOpen={isOpen}
      onClose={onClose}
      title="Tareas en segundo plano"
      width="w-[420px]"
      zIndex="front"
    >
      {jobs.length === 0 ? (
        <div className="rounded-sm border border-stroke bg-gray-2 p-4 text-sm text-body dark:border-strokedark dark:bg-meta-4 dark:text-bodydark">
          No hay tareas activas.
        </div>
      ) : (
        <div className="space-y-4">
          {jobs.map((job) => {
            const isDownloading =
              downloadingJobUuid === job.uuid;

            return (
              <BackgroundJobCard
                key={job.uuid}
                job={job}
                isDownloading={isDownloading}
                downloadProgress={
                  isDownloading
                    ? downloadProgress
                    : null
                }
                onDownload={(uuid) =>
                  handleDownload(
                    uuid,
                    job.fileName
                  )
                }
              />
            );
          })}
        </div>
      )}
    </SideDrawer>
  );
};

export default BackgroundJobsDrawer;